import { render, staticRenderFns } from "./IconRewind.vue?vue&type=template&id=54a5ca01&"
import script from "./IconRewind.vue?vue&type=script&lang=js&"
export * from "./IconRewind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a5ca01')) {
      api.createRecord('54a5ca01', component.options)
    } else {
      api.reload('54a5ca01', component.options)
    }
    module.hot.accept("./IconRewind.vue?vue&type=template&id=54a5ca01&", function () {
      api.rerender('54a5ca01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconRewind.vue"
export default component.exports